

import React from "react";
import "../css/MarketSpaceForm.css";
import { connect } from "react-redux";
import * as ActionTypes from "../actions/types";

class MarketSpaceFormEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            loader: true,
            snackbarActive: false,
            snackbarMessage: "",
            isChecked: false, // Initially checkbox is unchecked
            bannerImage: null, // To store the selected banner image
            iconImage: null, // To store the selected icon image
            offerInPercentage: "", // Store the value for offer in percentage
            couponId: "", // Store the value for coupon id
            fields: [], // Store the list of input field sets
            name: "",
            features: "",
            description: "",
            editorChoice: false,
            mostDownloaded: false,
            personalized: false,
            aiEnabled: false,
            freeTrialPeriod: 0,
            costPerDownload: "",
            status: "inactive",
            activeData: [],
            doewnloadsData: [],
            active_usersData: [],
        };
    }

    // Handle banner image upload
    handleBannerUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState({ bannerImage: file });
        }
    };

    // Handle icon image upload
    handleIconUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState({ iconImage: file });
        }
    };

    handleCheckboxChange = (event) => {
        this.setState({ isChecked: event.target.checked });
    };

    // Handle changes to the input fields
    handleInputChange = (event, field) => {
        this.setState({ [field]: event.target.value });
    };

    // Handle the "+" button click event to add a new set of fields
    handleAddField = () => {
        const { offerInPercentage, couponId } = this.state;

        if (offerInPercentage && couponId) {
            // Add new entry to fields array and reset the current inputs
            this.setState((prevState) => ({
                fields: [
                    ...prevState.fields,
                    { offerInPercentage, couponId },
                ],
                offerInPercentage: "",
                couponId: "",
            }));
        } else {
            alert("Please fill out all fields before adding.");
        }
    };
 
    componentDidMount() {
        // Extract 'id' from the query parameters (e.g., URL like /marketspaceFormEdit?id=15)
        const searchParams = new URLSearchParams(window.location.search);
        const itemId = searchParams.get("id"); // Get the `id` query parameter
        
        if (itemId) {
            this.fetchActiveService(itemId);
        } else {
            console.warn("No ID provided in the URL. Cannot fetch specific data.");
        }
    }

    fetchActiveService = (itemId) => {
        
        this.setState({ loader: true });
        const tokenStored = localStorage.getItem("token");
        const headers = {
            Authorization: `Token ${tokenStored}`,
            "X-CSRFToken": localStorage.getItem("csrftoken"),
        };

        fetch(`/cloud/apps/${itemId}`, {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                if (response.status === 403) {
                    // Remove session data
                    localStorage.removeItem("token");
                    localStorage.removeItem("csrftoken");
                    localStorage.removeItem("auth");
                } else {
                    return response.json();
                }
            })
            .then((data) => {
                // Find the specific record by ID
                // const selectedData = data.find((item) => item.id === parseInt(itemId));
                console.log(data)
                if (!data.id) {
                    console.error("No matching data found for the provided ID.");
                    this.setState({ loader: false });
                    return;
                }
              
                // Populate state with specific data for editing
                this.setState({
                    activeData: data, // All data in case it's still needed
                    doewnloadsData: data.downloads,
                    active_usersData: data.active_users,
                    name: data.name || "",
                    features: data.features || "",
                    description: data.description || "",
                    editorChoice: data.editor_choice || false,
                    mostDownloaded: data.most_downloaded || false,
                    personalized: data.personalized || false,
                    aiEnabled: data.ai_enabled || false,
                    freeTrialPeriod: data.free_trial_period || 0,
                    costPerDownload: data.cost_per_download || "",
                    fields:JSON.parse(data.offers),


                    loader: false,
                });
             
            })
            .catch((err) => {
                console.error(err);
                this.setState({ loader: false });
            });
    };




    handleFormSubmit = async (event) => {
        event.preventDefault();

        const {
            name,
            features,
            description,
            editorChoice,
            mostDownloaded,
            personalized,
            aiEnabled,
            freeTrialPeriod,
            costPerDownload,
            fields,
            bannerImage,
            iconImage,
            status,  // This status will be either 'active' or 'archived'
        } = this.state;

        // Validation only for 'archived' status
        if (status === 'archived' && !name) {
            alert('Name is required for draft.');
            return;  // Prevent form submission if name is missing for draft status
        }

        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored,
        };

        // Prepare FormData to send
        const formData = new FormData();
        formData.append("name", name);
        formData.append("features", features);
        formData.append("description", description);
        formData.append("editor_choice", editorChoice);
        formData.append("most_downloaded", mostDownloaded);
        formData.append("personalized", personalized);
        formData.append("ai_enabled", aiEnabled);
        formData.append("free_trial_period", freeTrialPeriod);
        formData.append("cost_per_download", costPerDownload);
        formData.append("status", status);  // Use the status stored in state

        // Append offers only if there are any
        if (fields && fields.length > 0) {
            formData.append("offers", JSON.stringify(fields));
        }

        // Only append the banner image if it exists
        if (bannerImage) formData.append("banner_image", bannerImage);

        // Only append the icon image if it exists
        if (iconImage) formData.append("icon_image", iconImage);

        try {
            const response = await fetch("/cloud/apps/", {
                method: "PUT",
                
                headers: headers,
                body: formData,
            });

            if (response.ok) {
                const data = await response.json();
                alert("Form submitted successfully!");
                window.location.href = '/marketspace';
            } else {
                alert("Failed to submit the form. Please try again.");
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            alert("An error occurred while submitting the form.");
        }
    };



    render() {
        const {
            bannerImage,
            iconImage,
            fields,
            offerInPercentage,
            couponId,
            name,
            features,
            description,
            isChecked,
            freeTrialPeriod,
            costPerDownload,
        } = this.state;


        // console.log(this.state)
        return (
            <div className="section-background-form">
                <div className="form-container">
                    {/* Left Section for Upload */}
                    <div className="left-section">
                        {/* Upload Banner Section */}
                        <div className="upload-box-banner">
                            {!bannerImage && (
                                <label htmlFor="uploadBanner" className="upload-label">
                                    UPLOAD BANNER
                                </label>
                            )}
                            <input
                                type="file"
                                id="uploadBanner"
                                className="file-input"
                                onChange={this.handleBannerUpload}
                            />
                            {bannerImage && <img src={URL.createObjectURL(bannerImage)} alt="Banner" className="uploaded-image" />}
                        </div>

                        {/* Upload Icon Section */}
                        <div className="upload-box-icon">
                            {!iconImage && (
                                <label htmlFor="uploadIcon" className="upload-label-icon">
                                    UPLOAD ICON
                                </label>
                            )}
                            <input
                                type="file"
                                id="uploadIcon"
                                className="file-input-icon"
                                onChange={this.handleIconUpload}
                            />
                            {iconImage && <img src={URL.createObjectURL(iconImage)} alt="Icon" className="uploaded-image-icon" />}
                        </div>

                        <br />
                        <div className="metrics">
                            <span data-label="Downloads">
                                <span>{this.state.doewnloadsData}+</span>
                            </span>
                            <span data-label="Active Users">
                                <span>{this.state.active_usersData}+</span>
                            </span>
                        </div>
                    </div>

                    {/* Right Section for Form */}
                    <div className="right-section">
                        <h2 className="form-title">Upload Your Application</h2>
                        <form onSubmit={this.handleFormSubmit}>
                            <div className="form-group">
                                <input
                                    type="text"
                                    placeholder="NAME OF THE APPLICATION:"
                                    value={name}
                                    onChange={(e) => this.handleInputChange(e, "name")}
                                />
                            </div>

                            <div className="form-group">
                                <input
                                    type="text"
                                    className="form-group-input"
                                    placeholder="FEATURES OF THE APPLICATION:"
                                    value={features}
                                    onChange={(e) => this.handleInputChange(e, "features")}
                                />
                            </div>

                            <div className="form-group">
                                <textarea
                                    placeholder="DESCRIPTION OF THE APPLICATION"
                                    value={description}
                                    onChange={(e) => this.handleInputChange(e, "description")}
                                />
                            </div>

                            <div className="checkbox-group">
                                <div className="checkbox-group-item">
                                    <input
                                        type="checkbox"
                                        id="editor-choice"
                                        onChange={(e) => this.setState({ editorChoice: e.target.checked })}
                                    />
                                    <label htmlFor="editor-choice">EDITOR’S CHOICE</label>
                                </div>
                                <div className="checkbox-group-item">
                                    <input
                                        type="checkbox"
                                        id="most-downloaded"
                                        onChange={(e) => this.setState({ mostDownloaded: e.target.checked })}
                                    />
                                    <label htmlFor="most-downloaded">MOST DOWNLOADED</label>
                                </div>
                                <div className="checkbox-group-item">
                                    <input
                                        type="checkbox"
                                        id="personalized"
                                        onChange={(e) => this.setState({ personalized: e.target.checked })}
                                    />
                                    <label htmlFor="personalized">PERSONALIZED</label>
                                </div>
                                <div className="checkbox-group-item">
                                    <input
                                        type="checkbox"
                                        id="ai-enabled"
                                        onChange={(e) => this.setState({ aiEnabled: e.target.checked })}
                                    />
                                    <label htmlFor="ai-enabled">AI-ENABLED</label>
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="form-group-free-trail">
                                    <div className="checkbox-group-item">
                                        <input
                                            type="checkbox"
                                            id="free-trail"
                                            // checked={isChecked}
                                            checked={freeTrialPeriod > 0 ? true : isChecked}  
                                            onChange={this.handleCheckboxChange}
                                        />
                                        <label htmlFor="free-trail">FREE TRAIL PERIOD:</label>
                                    </div>
                                    <input
                                        type="number"
                                        placeholder="Ex: 20 days"
                                        className="trial-days-input"
                                        disabled={!isChecked}
                                        value={freeTrialPeriod}
                                        onChange={(e) => this.handleInputChange(e, "freeTrialPeriod")}
                                        title={!isChecked ? "Please check the free trial box to enable the input." : ""}
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <input
                                    type="text"
                                    placeholder="COST PER DOWNLOAD"
                                    value={costPerDownload}
                                    onChange={(e) => this.handleInputChange(e, "costPerDownload")}
                                />
                            </div>

                            <div className="form-group-inline">
                                <input
                                    type="text"
                                    placeholder="OFFER IN %"
                                    value={offerInPercentage}
                                    onChange={(e) => this.handleInputChange(e, "offerInPercentage")}
                                />
                                <input
                                    type="text"
                                    placeholder="COUPON ID"
                                    value={couponId}
                                    onChange={(e) => this.handleInputChange(e, "couponId")}
                                />
                                <span className="plus-sign" onClick={this.handleAddField}>
                                    +
                                </span>
                            </div>

                            {/* Render the list of input fields */}
                            {fields.map((field, index) => (
                                <div key={index}>
                                    <div className="form-group-inline">
                                        <input type="text" value={field.offerInPercentage} readOnly placeholder="OFFER IN %" />
                                        <input type="text" value={field.couponId} readOnly placeholder="COUPON ID" />
                                    </div>
                                </div>
                            ))}

                            <div className="button-group">
                                <button type="submit" className="draft" onClick={() => this.setState({ status: 'archived' })} // Set status to archived when Draft is clicked
                                >EDIT DRAFT</button>
                                <button type="submit" className="upload" onClick={() => this.setState({ status: 'active' })} // Set status to active when Upload is clicked
                                >EDIT UPLOAD</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        redux: state,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketSpaceFormEdit);

